import { useNavigate, useParams } from 'react-router-dom';

// material mui
import {
    Typography,
    Grid,
    Avatar,
    Link,
    Chip,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project import
import DEFAULT_USER_IMAGE from 'assets/images/users/default_user.png';
import { BOOKING_STATUS, PAYMENT_STATUS, USER_TYPE } from 'store/constant';

// third party
import moment from 'moment';

const List = ({ rows, page, limit, viewType }) => {

    const theme = useTheme();
    const { venueUuid } = useParams();
    const navigate = useNavigate();

    const handleViewVenue = (venue_uuid) => {
        navigate(`/venue/view/${venue_uuid}`)
    };

    const getUserType = function (userType) {
        let findObj = USER_TYPE.find(x => x.value === userType);
        return findObj ? findObj.name : '';
    };

    const getBookingStatus = (booking_status) => {
        let findObj = BOOKING_STATUS.find(x => x.value === booking_status);
        return findObj ? findObj.name : '';
    };

    const capitalizeFLetter = (str) => {
        return str ? str.replace(/^\w/, (c) => c.toUpperCase()) : '';
    };

    const getPaymentStatus = (payment_status) => {
        let findObj = PAYMENT_STATUS.find(x => x.value === payment_status);
        return findObj ? findObj.name : '';
    };

    const getAmount = (amount) => {
        return parseFloat(amount).toFixed(2);
    };

    const handleBookingDetails = (bookingType, bookingId) => {
        if (venueUuid) {
            navigate(`/venue/view/${venueUuid}/${bookingType}/${bookingId}`);
        } else {
            navigate(`/bookings/${bookingType}/details/${bookingId}`);
        }
    }

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ pl: 3 }}>#</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} >Booking Id</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Customer</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>Venue</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Start Date</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>End Date</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Duration</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Actual / Paid</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align='center'>Payment Mode</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align='center'>Payment Type</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align='center'>Booking Status</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align='center'>Payment Status</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align='center'>Status</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Created By</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        rows.map((row, index) =>
                            <TableRow hover key={index}>
                                <TableCell sx={{ pl: 3 }}>{page * limit - limit + index + 1}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                <Link
                                                    sx={{ cursor: 'pointer' }}
                                                    onClick={() => { handleBookingDetails('court', row.uuid) }}
                                                >
                                                    {row.slot_id}
                                                </Link>
                                            </Typography>
                                            <Typography align="left" variant="subtitle2">
                                                {row.created_at ? moment(row.created_at).format('DD-MM-YYYY HH:mm:ss') : ''}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item>
                                            <Avatar alt="User" src={row.booked_user_image ? row.booked_user_image : DEFAULT_USER_IMAGE} />
                                        </Grid>
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.booked_user_firstname} {row.booked_user_lastname}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2">
                                                {row.booked_user_code} / {getUserType(row.booked_user_type)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {
                                                    viewType ? (row.venue_name ? row.venue_name : '') : (
                                                        <Link underline='always' onClick={() => handleViewVenue(row.uuid_venue)} sx={{
                                                            cursor: 'pointer'
                                                        }}>{row.venue_name ? row.venue_name : ''}</Link>
                                                    )
                                                }
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {row.court_name ? row.court_name : ''}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    <Typography align="left" variant="subtitle1" component="div">
                                        {row.start_date ? moment(row.start_date).format('DD-MM-YYYY') : ''}
                                    </Typography>
                                    <Typography align="left" variant="subtitle2" component="div">
                                        {row ? moment(row.start_date + ' ' + row.start_time + ':00', 'YYYY-MM-DD HH:mm:ss').format('hh:mm A') : ''}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    <Typography align="left" variant="subtitle1" component="div">
                                        {row.end_date ? moment(row.end_date).format('DD-MM-YYYY') : ''}
                                    </Typography>
                                    <Typography align="left" variant="subtitle2" component="div">
                                        {row ? moment(row.start_date + ' ' + row.start_time + ':00', 'YYYY-MM-DD HH:mm:ss').add(parseInt(row.duration), 'minutes').format('hh:mm A') : ''}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    <Typography align="left" variant="subtitle1" component="div">
                                        {row.duration} Minutes
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    {getAmount(row.actual_slot_price)} / {getAmount(row.subtotal)}
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.payment_mode === 'full' ? (
                                            <Chip
                                                label={capitalizeFLetter(row.payment_mode)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        ) : row.payment_mode === 'custom' ? (
                                            <Chip
                                                label={capitalizeFLetter(row.payment_mode)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        ) : row.payment_mode === 'na' ? '-' : (
                                            <Chip
                                                label={capitalizeFLetter(row.payment_mode)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.warning.light + 60,
                                                    color: theme.palette.warning.dark
                                                }}
                                            />
                                        )
                                    }
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.payment_type === 'offline' ? (
                                            <Chip
                                                label={capitalizeFLetter(row.payment_type)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        ) : !row.payment_type ? '-' : (
                                            <Chip
                                                label={capitalizeFLetter(row.payment_type)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        )
                                    }
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.booking_status === 'confirmed' ? (
                                            <Chip
                                                label={getBookingStatus(row.booking_status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        ) : (row.booking_status === 'failed' || row.booking_status === 'cancelled') ? (
                                            <Chip
                                                label={getBookingStatus(row.booking_status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        ) : (
                                            <Chip
                                                label={getBookingStatus(row.booking_status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.warning.light + 60,
                                                    color: theme.palette.warning.dark
                                                }}
                                            />
                                        )
                                    }
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.payment_type === 'offline' || row.payment_status === 'na' ? '-'
                                            : row.payment_status === 'confirmed' ? (
                                                <Chip
                                                    label={getPaymentStatus(row.payment_status)}
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.success.light + 60,
                                                        color: theme.palette.success.dark
                                                    }}
                                                />
                                            ) : row.payment_status === 'cancelled' ? (
                                                <Chip
                                                    label={getPaymentStatus(row.payment_status)}
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.error.light + 60,
                                                        color: theme.palette.error.dark
                                                    }}
                                                />
                                            ) : (
                                                <Chip
                                                    label={getPaymentStatus(row.payment_status)}
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.warning.light + 60,
                                                        color: theme.palette.warning.dark
                                                    }}
                                                />
                                            )
                                    }
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.deleted === 0 ? (

                                            <Chip
                                                label="Active"
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        ) : (
                                            <Chip
                                                label="Inactive"
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        )
                                    }
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.created_user_firstname} {row.created_user_lastname}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {row.created_user_code} / {getUserType(row.created_user_type)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        )
                    }
                </TableBody>
            </Table>
        </TableContainer >
    );
}

export default List;